module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAABLElEQVQoU53SMUvDQBQH8P87EQQHEQSRFDTtJt2SKN3ci7uKXXUS/ADi5JdQJwUHhw46urpIEy1CHRxMFC+lkk61aNX2nqS1Ia2liDfe8Xvvz3tH+Oeh0GlJ84mY9qRnHw6ro82Z20S0JT071YG6eUZES6qBdLlsPw/CCd1cANElwHnpOmttODVrzIwJUQLxlXSdbD+cTBoT4yxumND6qNWMavX+tQ1/uuaI6BjAunTtkzjWdOuUgGVGM+N7xdvwLYIdbJ2DkGm9NecrlWIQ3iV0awOEfTA2pWcfdAv2wG5kJr7wXWd1OmWmRxUVGMj7np2Lp+iB8chKYUUI7DKz+Ky/W0FwVx8Ko8jgLIEaX4IXXx6cUv/AfnWMpjwiCqzUjv94fTRoPQPhXz7TN3Aebwy1Ee9zAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom.png
// module id = MGEE
// module chunks = 2